import React from 'react';
import _TradeNewsContainer from './_TradeNewsContainer.scss';
import TradeNewsItem from 'components/partials/tradenews';
import {Articles} from 'api';
import {Link} from 'react-router-dom';
import Slider from 'slider';

class TradeNewsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 6,
      order: 'id DESC',
      categoryId: '5a04822ff75c7330ed575c09'
    }
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          categoryId: this.state.categoryId
        }
      }
    }
    Articles.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      })
    });
  }

  render() {
    const settings = {
      className: 'slider trade-slick',
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [{
        breakpoint: 1201,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    };
    return (
      <section className='trade-category-container'>
        <div className='center'>
          <div className='trade-category-wrap'>
            <div className='trade-left-content'>
              <p className='title-black '><Link to={`/news-category/${this.state.categoryId}`}>Thông tin - Sự kiện - Thông báo</Link></p>
            </div>
            <div className='trade-right-content'>
              <Slider {...settings}>
                {
                  this.state.data.map((item,i) => {
                    return(
                      <div key={i}>
                        <TradeNewsItem {...item}/>
                      </div>
                    )
                  })
                }
              </Slider>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default TradeNewsContainer;



// WEBPACK FOOTER //
// ./components/home/sub-view/TradeNewsContainer.jsx